/**
 * skerpaPreferencesStore — persisted user preferences for Skerpa coach behavior.
 * Kept separate from skerpaContextStore (which holds ephemeral view state).
 */

import { create } from 'zustand'
import { persist } from 'zustand/middleware'

interface SkerpaPreferencesState {
  /** Whether to auto-greet when navigating to a new view (with chat history). */
  autoGreet: boolean
  /** Whether the persistent "Next 3 Moves" strip above the chat input is shown. */
  showMovesStrip: boolean
  setAutoGreet: (value: boolean) => void
  setShowMovesStrip: (value: boolean) => void
}

export const useSkerpaPreferencesStore = create<SkerpaPreferencesState>()(
  persist(
    (set) => ({
      autoGreet: true,
      showMovesStrip: true,
      setAutoGreet: (value) => set({ autoGreet: value }),
      setShowMovesStrip: (value) => set({ showMovesStrip: value }),
    }),
    {
      name: 'ispot-skerpa-preferences',
    },
  ),
)
